import {
  postReport,
  getAuthorization,
  getCredentials,
  postJasperReport,
} from 'api/pgads'
import moment from 'moment'
import { message } from 'antd'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import {
  getCode,
  getRadioSelection,
  isRadioSelectionAvaliable,
} from './reportVisibleStatus2'
import R from 'ramda'
import { NRG_CLIENT } from 'client'

export const getDate = data => {
  let { startDate, endDate } = data

  endDate =
    !data.visibleEndDate && !data.visibleMonthYearEnd ? startDate : endDate

  startDate = data.visibleStartDate
    ? startDate.format('MM/DD/YYYY')
    : data.visibleStartYear
    ? startDate
        .clone()
        .startOf('year')
        .format('MM/DD/YYYY')
    : moment(
        `${data.monthyear.year + data.monthyear.month}01`,
        'YYYYMMDD'
      ).format('MM/DD/YYYY')

  // let startDate = startDate.format('MM/DD/YYYY')
  endDate = data.visibleEndDate
    ? endDate.format('MM/DD/YYYY')
    : data.visibleEndYear
    ? endDate
        .clone()
        .endOf('year')
        .format('MM/DD/YYYY')
    : moment(
        `${data.monthyearend.year + data.monthyearend.month}01`,
        'YYYYMMDD'
      )
        .endOf('month')
        .format('MM/DD/YYYY')

  // let startHour = data.visibleStartHour ? data.selectedStartHour - 1 : data.selectedStartHour

  let startHour = data.selectedStartHour
  startHour = `${startHour}`.length === 1 ? `0${startHour}` : startHour
  startDate =
    data.visibleStartHour &&
    data.selectedStartHour === 0 &&
    data.selectedEndHour === 24
      ? startDate
      : `${startDate} ${startHour}`

  let endHour = data.selectedEndHour
  endHour =
    `${endHour}`.length === 1 ? `0${endHour}` : endHour === 24 ? '00' : endHour
  endDate =
    data.visibleEndHour &&
    data.selectedEndHour === 24 &&
    data.selectedStartHour === 0
      ? endDate
      : `${endDate} ${endHour}`

  const causeCodeValuesObj = data.allCauseCode ? [] : data.causeCodeValues
  // R.flatten(data.causeCodeValues.map(d => Object.keys(d).map(v => d[v])))
  const isNotUtility =
    data.visibleStation === false && data.visibleUnit === false

  return {
    startDate,
    endDate,
    STARTDATE:
      data.visible10StartEndMonth || data.visible6StartEndDate
        ? data.dateMapStart
        : startDate,
    ENDDATE:
      data.visible10StartEndMonth || data.visible6StartEndDate
        ? data.dateMapEnd
        : endDate,
    causeCodeValues: causeCodeValuesObj,
    causeCodeKeyValues: [],
    selStations: data.visibleMAGroup
      ? data.selMaGroup
      : (data.selStations || []).map(s => s.unitId),
    // selStations:data.visibleMAGroup ? data.selMaGroup :
    selUtility: isNotUtility ? [] : data.selUtility,
  }
}

export default (targetInfo, xdata) => {
  // this is simplest date
  const { setUnitUtility, ...data } = xdata
  // TYPEBY:PJM=1,NERC=2, both not selected/ not added =0
  if (!(data.selectedReportName && data.selectedReportName.length > 0)) {
    message.error('Please, Select Reportname')
    return false
  }
  if (
    data.visibleUnit &&
    data.choiceUnitStation === 'unit' &&
    data.selUnits.length <= 0
  ) {
    message.error('Please, Select Unit(s)')
    return false
  }
  if (
    data.visibleStation &&
    data.choiceUnitStation === 'station' &&
    data.selStations.length <= 0
  ) {
    message.error('Please, Select Station(s)')
    return false
  }
  if (data.visibleMAGroup && (data.maGroupSelection || []).length <= 0) {
    message.error('Please select group(s)')
    return false
  }
  if (
    data.visibleWindSubgroupSelection &&
    (data.windSelection || []).length <= 0
  ) {
    message.error('Please select wind groups')
    return false
  }

  if (data.selectedReportName === 'HR Performance Factor') {
    if (data.selUnits.length > 1) {
      message.error('Please, select only 1 Unit.')
      return
    }
  }
  if (data.reportId === '30' && data.CLIENT === NRG_CLIENT) {
    if (data.maGroupSelection.length > 1) {
      message.error('Please, select only 1 Group.')
      return
    }
  }
  const displayCode = data.reportDisplayCodeMap[data.reportId]
  const rollupdetailVisible = getRadioSelection(
    getCode(displayCode, 7),
    data.CLIENT
  )
  const isAvaliable = isRadioSelectionAvaliable(rollupdetailVisible)
  const rollupdetail = isAvaliable ? data.rollupdetail : undefined
  const unitIds = (setUnitUtility || []).map(d => d.unitId)

  const rdata = {
    ...data,
    ...getDate(data),
    setUnitUtility: unitIds,
    rollupdetail,
    // selUtility:
    //   data.visibleUnit || data.visibleWindSubgroupSelection
    //     ? data.selUtility
    //     : data.selUtilityStation,
    eafOnly: data.eafOnly === 'Y' ? 'Y' : 'N',
    omc: data.visibleErrorCodeCheckbox ? '3' : data.omc,
    // TYPEBY: data.visiblePjmNerc ? data.typeBy : '0',
    // typeBy: data.visiblePjmNerc ? data.typeBy : '0',
    EXEVENT: R.compose(
      R.fromPairs,
      R.filter(([_, v]) => !!v.unitid),
      R.toPairs
    )(data.EXEVENT || {}),
  }

  let ps
  if (data.jasper) ps = postJasperReport(targetInfo)(rdata)
  else ps = postReport(targetInfo)(rdata)

  if (!data.BACKGROUND) data.setLoading(true)

  ps.fork(data.setErr, mapData => {
    // const fname = encodeURIComponent(filename.fileName)
    const error = mapData.ERRORS || []
    if (!data.BACKGROUND && !isErrorContains(error)) {
      downloadFile(targetInfo)(mapData.fileName, true)
      mapData.fileName2 && downloadFile(targetInfo)(mapData.fileName2, true)
    } else if (error.length > 0) {
      data.setTmpError(error)
    }
    data.setLoading(false)
  })

  return true
}

export const downloadFile = targetInfo => (fileName, deleteFile = false) => {
  const URL = `${
    targetInfo.baseUrl
  }/report/download-report?deleteFile=${deleteFile}&&filename=${encodeURIComponent(
    fileName
  )}`
  return fetch(`${URL}`, {
    method: 'GET',
    ignoreAuth: false,
    ...getCredentials(targetInfo),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/octet-stream',
      // jwt: targetInfo.jwt == undefined ? null : targetInfo.jwt,
      ...getAuthorization(targetInfo),
    },
    // body:JSON.stringify(data)
  })
    .then(response => {
      if (response.ok) return response
      else {
        response
          .blob()
          .then(b => b.text())
          .then(res => console.log(JSON.parse(res)))
          .catch(e => console.log(e))
        throw new Error('Something went wrong')
      }
    })
    .then(response => response.blob())
    .then(blob =>
      exportData(blob, 'application/pdf', decodeURIComponent(fileName))
    )
    .catch(error => message.error('Error in Reports ' + error))
}

const exportData = (blob, type, fileName) => {
  const a = window.document.createElement('a')
  a.href = window.URL.createObjectURL(blob, { type })
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
